export default function formatBalance(amount, showDecimal = true, currencySymbol = "$", currencySymbolBefore = false, thousandSeparator = " ", comma = ",") {
  const parts = (amount / 100).toFixed(2).split(".");

  return (currencySymbolBefore ? currencySymbol : "") + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator) + (showDecimal ? comma + parts[1] : "") + (currencySymbolBefore || !currencySymbol ? "" : " " + currencySymbol);
};